import {toV2Structure} from '../utils/version-converters';
import {ENV_CONFIGS} from '../constants/envs';
import {tokenExpired} from '../app/actions';
import lodashGet from 'lodash/get';
import axios from 'axios';
import {addAuthTokenV1, buildGetParams, mapRequestToV1Structure} from '../utils/issues-v1-helpers';
import {TYPE_QUALITY_ISSUES} from '../constants/issue-types';
import {ISSUES_PERMISSIONS_V1_ENDPOINT, QUALITY_ISSUES_ENDPOINT} from '../constants/issues-v1-endpoints';

export default class {
  constructor(dispatch, getState) {
    this.dispatch = dispatch;
    this.getState = getState;
    this.axiosClient = axios.create({
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  setAxiosClient(apiConfig) {
    const {containerId} = apiConfig;
    const issuesV1URL = `${ENV_CONFIGS.APIGEE_HOST}${ENV_CONFIGS.ISSUES}`;
    this.axiosClient.defaults.baseURL = `${issuesV1URL}/containers/${containerId}/`;
    this.setInceptors();
  }

  setInceptors() {
    this.axiosClient.interceptors.request.use(config => addAuthTokenV1(config, this.getState, this.dispatch));
    this.axiosClient.interceptors.response.use(
      response => response.data,
      error => {
        if (lodashGet(error, 'response.status') === 401) {
          this.dispatch(tokenExpired());
        }
        return Promise.reject(error);
      }
    );
  }
  setConfig(apiConfig) {
    this.setAxiosClient(apiConfig);
  }

  getQualityIssues(query) {
    return this.axiosClient
      .get(QUALITY_ISSUES_ENDPOINT, {params: buildGetParams(query)})
      .then(({data, meta, links}) => data.map(resource => toV2Structure(resource, {meta, links})));
  }
  getCsvQualityIssues(query) {
    return this.axiosClient
      .get(QUALITY_ISSUES_ENDPOINT, {params: buildGetParams(query)})
      .then(data => [{payload: data}]);
  }

  getQualityIssueById(qualityIssueId) {
    return this.axiosClient
      .get(`${QUALITY_ISSUES_ENDPOINT}/${qualityIssueId}`)
      .then(({data, meta, links}) => toV2Structure(data, {meta, links}));
  }

  updateQualityIssue({id}, attributes) {
    return this.axiosClient
      .patch(`${QUALITY_ISSUES_ENDPOINT}/${id}`, mapRequestToV1Structure(attributes, TYPE_QUALITY_ISSUES, true, id))
      .then(({data, meta, links}) => toV2Structure(data, {meta, links}));
  }

  createQualityIssue(attributes) {
    return this.axiosClient
      .post(QUALITY_ISSUES_ENDPOINT, mapRequestToV1Structure(attributes, TYPE_QUALITY_ISSUES, true))
      .then(({data, meta, links}) => toV2Structure(data, {meta, links}));
  }

  fetchIssuesPermissions() {
    return this.axiosClient
      .get(ISSUES_PERMISSIONS_V1_ENDPOINT)
      .then(({data, meta, links}) => data.map(resource => toV2Structure(resource, {meta, links})));
  }

  updateIssuesPermissions(permissionId, permissions) {
    return this.axiosClient
      .patch(
        `${ISSUES_PERMISSIONS_V1_ENDPOINT}/${permissionId}`,
        mapRequestToV1Structure(permissions, ISSUES_PERMISSIONS_V1_ENDPOINT, false, permissionId)
      )
      .then(({data, meta, links}) => toV2Structure(data, {meta, links}));
  }

  deleteIssuesPermissions(id) {
    return this.axiosClient.delete(`${ISSUES_PERMISSIONS_V1_ENDPOINT}/${id}`);
  }
}
